// @flow
import type { ActionsState } from '~/core/state/actions/types';

import { connect } from 'react-redux';
import {
    getActionsListOfProductId,
    getOrderedActionsList,
    getIsLoadingActionsList
} from '~/core/state/actions/selectors';
import Component from './component';

type Props = { productId: ?string };
const mapStateToProps = (state: { actions: ActionsState }, { productId }: Props): * => {
    const list = productId ? getActionsListOfProductId(state, { id: productId }) : getOrderedActionsList(state);
    const isLoading = getIsLoadingActionsList(state);

    return { actions: list, isLoading };
};

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/my-actions/index.js